import React , { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';

import {
	Routes,
	Route,
	useLocation,
	useNavigate,
} from "react-router-dom";

import useStore from './store/store';

import User from './components/user/User';
import Wallet from './components/wallet/Wallet';
import TicketList from './components/events/ticketList/TicketList';
import CheckoutTicket from './components/events/checkout/CheckoutTicket';
import TicketSpec from './components/wallet/tickets/TicketSpec/TicketSpec';

import client from './assets/service/client';
import { Container } from './styles';
import Loader from './assets/components/loader/Loader';
import CardPaymentSuccess from './components/events/checkout/CardPaymentSuccess';
import Head from './components/head/Head';
import Redirect from './assets/components/Redirect';
import Home from './components/home/Home';
import Menu from './components/menu/Menu';
import CommunicationPreference from './assets/components/communicationPreference/CommunicationPreference';

import Grant from './components/grant/Grant';
import ForgotPasswordForm from './assets/components/forgot/ForgotPasswordForm';
import HomeValidateGuests from './components/homeValidateGuests/HomeValidateGuests';

const App = () => {
	const location = useLocation();
	const [loading, setLoading] = useState(true);

	const [menuVisibility, setMenuVisibility] = useState(false);

	const navigate = useNavigate();

	const setUser = useStore(state => state.setUser);
	const dropUser = useStore(state => state.dropUser);

	const user = useStore(state => state.user);

	const ping = () => {
		client.get('auth/ping')
		.then(res => {
			console.log('logged')
			setUser(res.data.user);
		})
		.catch(err => {
			dropUser();
		})
		.finally(onFinally => setLoading(false))
	}

	const toggleSideMenu = () => {
		setMenuVisibility(!menuVisibility);
	}

	useEffect(() => {
		ping();
	}, []);


	// comment this useEffect to remove guests
	// useEffect(() => {
	// 		if (!localStorage.getItem("valid")) {
	// 			navigate("convidados")
	// 		}
	// }, []);

	return (
		location.pathname === "/" ? <Home /> :
		<>
			{ user && !user.communicationId && <CommunicationPreference ping={ping}/> }
			<Menu pathName={location.pathname} onClose={toggleSideMenu} isVisible={menuVisibility} />
			<Head onMenuClick={toggleSideMenu} />
			<Container>
			{
			loading ?
				<Loader />
			:
			<AnimatePresence exitBeforeEnter={true} initial={false}>
				{/* <div style={{minHeight: "70px"}} /> */}
				<Routes location={location} key={location.pathname}>
					<Route exact path="/events" element={<TicketList />} />
					<Route exact path="/events/:alias" element={<TicketList />} />
					<Route exact path="/events/:alias/tickets" element={<TicketList />} />
					<Route exact path="/events/:alias/tickets/checkout" element={<CheckoutTicket />} />
					<Route exact path="/wallet" element={<Wallet tickets={true} />} />
					<Route exact path="/wallet/tickets" element={<Wallet tickets={true} />} />
					<Route exact path="/wallet/tickets/:id" element={<TicketSpec />} />
					<Route exact path="/user" element={<User />} />
					
					<Route exact path="/grant/:code" element={<Grant />} />
					<Route exact path="/forgot/email" element={<ForgotPasswordForm />} />

					{/* <Route exact path="/convidados" element={<HomeValidateGuests />} /> */}

					<Route exact path="/redirect" element={<Redirect />} />
					<Route path="payment-succeeded" element={<CardPaymentSuccess />} />
					<Route path="/*" element={<>404</>} />
				</Routes>
			</AnimatePresence>
			}
			</Container>
		</>
	);
}

export default App;
